import React, { useEffect, useState } from "react";
import { Paper } from "@mui/material";
import { action, API, controller } from "../../api/api";
import { useFormatPrice } from "hooks";

const SalesAvg = () => {
  const formatPrice = useFormatPrice();
  const [value, setValue] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    API(controller.HomeReport + action.InventoryReport).get((res) => {
      res && res.status === 200 && setValue({ ...res.result });
      setLoading(false);
    });
    return () => {};
  }, []);

  return !loading ? (
    <Paper
      className="bg-white h-full grid  rounded-xl overflow-hidden transform transition-all duration-300"
      elevation={3}
    >
      {/* Outlets */}
      <div className="grid grid-cols-1 divide-y divide-gray-100">
        <div className="p-8 bg-gradient-to-br from-gray-50 to-white">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
            <span className="text-base font-medium text-gray-500 uppercase tracking-wider">
              Total Inventory Value
            </span>
          </div>
          <span className="mt-4 block text-3xl font-bold text-gray-600 tabular-nums">
            {formatPrice(value.totalInventoryValue)}
          </span>
          <span className="mt-1 block text-sm font-normal text-gray-400">
            As of {new Date().toLocaleDateString()}
          </span>
        </div>
        <div className="p-8">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
            <span className="text-base font-medium text-gray-500 uppercase tracking-wider">
              Total Inventory
            </span>
          </div>
          <span className="mt-4 block text-3xl font-bold text-gray-600 tabular-nums">
            {formatPrice(value.totalInventoryUnits)}
          </span>
          <span className="mt-1 block text-sm font-normal text-gray-400">
            Current Stock Units
          </span>
        </div>
      </div>
    </Paper>
  ) : (
    "Loading..."
  );
};

export default SalesAvg;
